import { render } from "./HomeLayout.vue?vue&type=template&id=2f06da32&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"

import "./HomeLayout.vue?vue&type=style&index=0&id=2f06da32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f06da32"]])

export default __exports__